module.exports = __webpack_public_path__ + "c25cb31e4c1e48967df609f585b7fd9f.svg";